import { AppBar, Box, Divider, Grid, Paper, PaperProps, SxProps, Theme, Toolbar, Typography, useTheme } from "@mui/material";
import React from "react";
import { IconType } from "react-icons/lib";

interface CardHeaderProps {
  icon?: IconType;
  iconSize?: string | number;
  title?: string;
  color: string;
  appBarColor?: string;
}

const AppBarCardHeader = (props: CardHeaderProps) => {
  const Icon = props.icon;
  const { color, title, iconSize } = props;
  const theme = useTheme();

  return (
    <AppBar
      position="relative"
      style={{
        background: theme.palette.primary.main,
        borderRadius: "16px 16px 0px 0px",
      }}
    >
      <Toolbar>
        {Icon && (
          <Grid
            style={{ background: color }}
            sx={{
              height: "54px",
              width: "54px",
              display: "flex",
              position: "absolute",
              zIndex: 1,
              top: -20,
              left: 12,
              borderRadius: "25%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon size={iconSize || "28px"} color={"#ffffff"} />
          </Grid>
        )}
        <Box
          sx={{
            flex: 1,
          }}
        />
        <Typography
          variant="h6"
          component="div"
          sx={{
            pr: 5,
          }}
        >
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

const CardHeader = (props: CardHeaderProps) => {
  const { color, title, iconSize } = props;
  const Icon = props.icon;
  const theme = useTheme();

  return (
    <Grid
      container
      sx={{
        borderRadius: "16px 16px 0px 0px",
        position: "relative",
        // background: theme.palette.background.default,
      }}
    >
      {Icon && (
        <Grid
          style={{ background: color }}
          sx={{
            height: "54px",
            width: "54px",
            display: "flex",
            position: "absolute",
            zIndex: 1,
            top: -20,
            left: 12,
            borderRadius: "25%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Icon size={iconSize || "28px"} color={"#ffffff"} />
        </Grid>
      )}
      <Grid
        container
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          padding: theme.spacing(1),
          margin: theme.spacing(1),
          minHeight: "64px",
          background: theme.palette.background.paper,
          borderRadius: "16px 16px 0px 0px",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textAlign: "right",
            width: "100%",
            pr: 5,
          }}
        >
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};

type WcIconCardProps = {
  id?: string;
  icon?: IconType;
  iconSize?: string | number;
  appBar?: boolean;
  className?: string;
  paperBg?: boolean;
  title?: string;
  color: string;
  sx?: SxProps<Theme>;
} & PaperProps;

export const WcIconCard = (props: React.PropsWithChildren<WcIconCardProps>) => {
  const theme = useTheme();
  return (
    <Paper
      className={props.className ? props.className : ""}
      variant="outlined"
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        margin: 0,
        padding: 0,
        background: props.paperBg ? theme.palette.background.paper : theme.palette.background.default,
        borderRadius: props.appBar ? "16px 16px 0px 0px" : "none",
        display: "flex",
        flexDirection: "column",
      }}
      id={props.id}
      // {...props}
    >
      {props.appBar ? (
        <AppBarCardHeader title={props.title} icon={props.icon} color={props.color} iconSize={props.iconSize} />
      ) : (
        <CardHeader title={props.title} icon={props.icon} color={props.color} iconSize={props.iconSize} />
      )}
      <Divider style={{ color: "#000" }} />
      <Grid
        container
        sx={[
          {
            justifyItems: "start",
            flexGrow: 1,
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
      >
        {props.children}
      </Grid>
    </Paper>
  );
};

export default WcIconCard;
